// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bmiQ","content":"styles_content__3xjG6"};